export const NumberUtils = {

  generateRandomID: () => '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36)

}

export default NumberUtils
